export default __webpack_public_path__ + "static/media/tokenomics.8374095d.png";